import { Box, Container, Stack, Text, Title, useMantineTheme } from "@mantine/core";
import { motion } from "framer-motion";
import classes from "./PageHeader.module.css";

interface PageHeaderProps {
  title: string;
  subtitle: string;
}

function PageHeader({ title, subtitle }: PageHeaderProps) {
  const theme = useMantineTheme();
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <Box
      className={classes.wrapper}
      data-component="PageHeader"
      py={"xl"}
      style={{
        background: `linear-gradient(180deg, ${theme.colors.primary[0]} 0%, white 100%)`,
      }}
    >
      <Container size="xl">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <Stack gap="xl" align="center">
            <motion.div variants={itemVariants}>
              <Title
                order={1}
                display="inline-block"
                ta="center"
                style={(theme) => ({
                  background: `linear-gradient(45deg, ${theme.colors.primary[6]}, ${theme.colors.tertiary[6]}, ${theme.colors.secondary[6]}, ${theme.colors.primary[6]})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "3.5rem",
                  fontWeight: 900,
                })}
              >
                {title}
              </Title>
            </motion.div>
            <motion.div variants={itemVariants}>
              <Text size="xl" c="dimmed" ta="center">
                {subtitle}
              </Text>
            </motion.div>
          </Stack>
        </motion.div>
      </Container>
    </Box>
  );
}

export default PageHeader;
